module.exports = {"after-dtp":"#b70101","credited":"#6e0fad","pod-zakaz":"#029ca9","not-used-in-ua":"#0b03ba","not-custom":"#159753","credit":"#baa000","rassrochka":"#38b193"}


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/statusColors.json
// module id = 2756
// module chunks = 32 36